export function isInternalManproProject(project: Record<string, unknown> | null | undefined): boolean {
  if (!project) {
    return false;
  }

  if (typeof project.is_internal === "boolean") {
    return project.is_internal;
  }

  if (typeof project.has_client_owner === "boolean") {
    return project.has_client_owner === false;
  }

  return !project.owner_project && !project.ownerProject;
}
